export const lxyLangEs = {
    dashbordlxy: { welcome: 'Bienvenido a la plataforma' },
    menuLxy: {
        lawyerFirmList: '律所页面'
    },
    lawyerLxy: {
        LawyerLetter: '律师函状态',
        LawyerStatus_UNDSend: "未发送", // 未发送
        LawyerStatus_Cancel: "撤回", // 撤回
        change: '修改',
        sendToOther: "转发三方律师函",
        Applycounts: "申请次数"
    },
    dataModulelxy: {
        dataModule: 'Módulos de datos',
        dataList: "Datos de casos",
        anomalyStatistics: "anomaly statistics",
        loginOrnot: 'Iniciar la sesión o no',
        KeyIndicators: 'Cantidad de aprobados',
        AuditCompleted: 'Cantidad de terminados por revisión',
        uncomplete: 'Orden de trabajo sin terminar',
        passAmount: 'Cantidad de aprobados',
        invalidAmount: 'Cantidad de inefectivos',
        rejectAmount: 'Cantidad de rechazados',
        passRate: 'Tasa de aprobación',
        invalidRate: 'Tasa de fracaso',
        rejectRate: 'Tasa de rechazo',
        QualityCheckAmount: 'Cantidad de muestreos por calidad',
        QualitypassAmount: 'Cantidad de aprobados por calidad',
        QualityjectAmount: 'Cantidad de rechazados por calidad',
        GenerateTicketAmount: 'Números de casos creados',
        assignmentTicketAmount: 'Números de casos asignados',
        finishTicketAmount: 'Casos terminados',
        passAmountAndRate: 'Cantidad y porcentaje de aprobados',
        overruleAmountAndRate: 'Cantidad y porcentaje de regresados',
        rejectAmountAndRate: 'Cantidad y porcentaje de rechazados',
        QualitypassAmountAndRate: 'Cantidad y porcentaje de aprobados por calidad',
        QualityCheck: 'Inspeccion de calidad',
        EveryItemTime: 'Tiempo de procesamiento por pieza',
        RankEmployeesGroup: 'Rango de empleados en el grupo',
        TeamData: 'Datos del equipo',
        avgHandleTicketNum: 'Promedio de carteras procesada por persona',
        avgAnswerNum: 'Promedio de carteras contactada',
        avgClosureAmount: 'Promedio de monto finalizada',
        newOnceClosureNum: 'Cartera nueva de una sola vez',
        newNotOnceClosureNum : 'Cartera nueva reusable',
        oldClosureNum: 'Cartera antigua',
        otherClosureNum: 'Otros',
        dailyClosureMetrics: 'Finalizada/monto/porcentaje',
    }

};

